import { gql } from "@apollo/client";

export default gql`
  query getOrganizationLocationsQuery($organizationId: Int!) {
    organization(pk: $organizationId) {
      id
      availableLocations
    }
  }
`;
